import React from 'react';
import EmptyInvoice from './EmptyInvoice';
import InvoiceTable from './InvoiceTable';
import InvoiceSummary from './InvoiceSummary';
import '../styles/InvoicePanel.css';

const InvoicePanel = ({
  invoiceNumber,
  items,
  total,
  onRemoveItem,
  onRowKeyDown,
  onCompleteSale,
  onClearAll
}) => {
  return (
    <div className="right-panel">
      <div className="card invoice-card">
        <div className="invoice-header">
          <h2 className="card-title">
            <span className="icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="size-6">
                <path fillRule="evenodd" d="M7.502 6h7.128A3.375 3.375 0 0 1 18 9.375v9.375a3 3 0 0 0 3-3V6.108c0-1.505-1.125-2.811-2.664-2.94a48.972 48.972 0 0 0-.673-.05A3 3 0 0 0 15 1.5h-1.5a3 3 0 0 0-2.663 1.618c-.225.015-.45.032-.673.05C8.662 3.295 7.554 4.542 7.502 6ZM13.5 3A1.5 1.5 0 0 0 12 4.5h4.5A1.5 1.5 0 0 0 15 3h-1.5Z" clipRule="evenodd" />
                <path fillRule="evenodd" d="M3 9.375C3 8.339 3.84 7.5 4.875 7.5h9.75c1.036 0 1.875.84 1.875 1.875v11.25c0 1.035-.84 1.875-1.875 1.875h-9.75A1.875 1.875 0 0 1 3 20.625V9.375ZM6 12a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75H6.75a.75.75 0 0 1-.75-.75V12Zm2.25 0a.75.75 0 0 1 .75-.75h3.75a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75ZM6 15a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75H6.75a.75.75 0 0 1-.75-.75V15Zm2.25 0a.75.75 0 0 1 .75-.75h3.75a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75ZM6 18a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75H6.75a.75.75 0 0 1-.75-.75V18Zm2.25 0a.75.75 0 0 1 .75-.75h3.75a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75Z" clipRule="evenodd" />
              </svg>
            </span>
            Current Invoice
          </h2>
          <span className="invoice-number">INV-{invoiceNumber}</span>
        </div>

        {items.length === 0 ? (
          <EmptyInvoice />
        ) : (
          <div className="invoice-content">
            <InvoiceTable
              items={items}
              onRemoveItem={onRemoveItem}
              onRowKeyDown={onRowKeyDown}
            />
            <InvoiceSummary
              total={total}
              onCompleteSale={onCompleteSale}
              onClearAll={onClearAll}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default InvoicePanel;